export class Stage1 {
    validate() {
        // stage 1 checks that there is something selected for registration options
        
        return Alpine.store('status').currentDelegate().registration_options.length > 0;
    }
}